import { render, staticRenderFns } from "./PointHeader.vue?vue&type=template&id=b0dd48d6&scoped=true&"
import script from "./PointHeader.vue?vue&type=script&lang=js&"
export * from "./PointHeader.vue?vue&type=script&lang=js&"
import style0 from "./PointHeader.vue?vue&type=style&index=0&id=b0dd48d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd48d6",
  null
  
)

export default component.exports